import FormTitle from '@core/components/FormTitle';
import Timeline from '@core/components/Timeline';
import moment from 'moment';
import React from 'react';
import { FaRegCheckCircle, FaRegTimesCircle } from 'react-icons/fa';
import { historicoSituacaoVendaStyles } from './styles';

const HistoricoSituacaoVenda = ({ historico }) => {
  const styles = historicoSituacaoVendaStyles();

  const getDescricaoSituacao = (situacao) => {
    switch (situacao) {
      case 'EM_ORCAMENTO':
        return 'Em orçamento';
      case 'VENDA_APROVADA':
        return 'Venda aprovada';
      case 'ORCAMENTO_RECUSADO':
        return 'Orçamento recusado';
      default:
        return '';
    }
  };

  const getIcone = (registro) => {
    switch (registro.situacaoAtual) {
      case 'EM_ORCAMENTO':
        return <FaRegTimesCircle size={30} className={styles.iconeEmOrcamento} />;
      case 'VENDA_APROVADA':
        return <FaRegCheckCircle size={30} className={styles.iconeVendaAprovada} />;
      case 'ORCAMENTO_RECUSADO':
        return <FaRegTimesCircle size={30} className={styles.iconeOrcamentoRecusado} />;
      default:
        return '';
    }
  };

  const getDataHora = (registro) => {
    return moment(registro.dataHora).format('HH:mm [do dia] DD/MM/YYYY');
  };

  const getDescricao = (registro) => {
    if (registro.cadastro) {
      return `${registro.nomeUsuario} cadastrou a venda com a situação "${getDescricaoSituacao(
        registro.situacaoAtual
      )}".`;
    }
    return `${registro.nomeUsuario} alterou a situação da venda de  "${getDescricaoSituacao(
      registro.situacaoAnterior
    )}" para "${getDescricaoSituacao(registro.situacaoAtual)}".`;
  };

  return (
    <>
      <FormTitle title="Histórico de alterações" />
      <Timeline registros={historico} getIcone={getIcone} getSubtitulo={getDataHora} getDescricao={getDescricao} />
    </>
  );
};

export default HistoricoSituacaoVenda;
